import { translate } from '../../../../helpers/translations/translator'

export default function getEditTrackError(
    dateError: boolean,
    payrollPeriodError: boolean,
    overlapError: boolean = false,
): string | null {
    if (dateError) {
        return translate('pages.tracks.endDateAndEndTimeNeedsToBeLaterThanStartDate')
    }

    if (payrollPeriodError) {
        return translate('common.datesOverlapWithLockedPayrollPeriod')
    }

    if (overlapError) {
        return translate('pages.tracks.trackOverlapsWithExistingTrack')
    }

    return null
}
